import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  main: {
    zIndex: 1,
    width: 'auto',
    display: 'block', // Fix IE 11 issue.
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    [theme.breakpoints.up(400 + theme.spacing(6))]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    marginTop: '5em',
    [theme.breakpoints.down('tablet')]: {
      marginTop: '0',
    },
  },
  headerCaption: {
    fontSize: '0.95rem',
    marginBottom: '-10px'
  },
  branding: {
    width: '280px',
    marginBottom: '30px'
  },
  paper: {
    marginTop: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`,
    [theme.breakpoints.down('tablet')]: {
      boxShadow: 'none',
    },
    background: 'white',
  },
  avatar: {
    margin: theme.spacing(3),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    color: 'white',
    fontWeight: 'bold',
  },
  errorLabel: {
    color: 'red',
    position: 'absolute'
  }
}))
